module.exports = __webpack_public_path__ + "media/wave5.75455a81.mp4";